import React from 'react'
import RichText from '../rich-text'
import FaqAccordion from '../help-center/accordion'

const AccordionSection = ({ accordionSectionDescription, accordionList }) => {
  return (
    <div className='w-full flex flex-col'>
      {accordionSectionDescription && <RichText text={accordionSectionDescription} className={'px-5'} />}
      <div className='flex w-full flex-col'>
        {accordionList && accordionList.map(accordion => (
          <FaqAccordion
            key={accordion._key}
            question={accordion.title}
            answer={accordion.description}
            questionClassname='pl-10'
            answerClassname='pl-5'
            isRichText
          />
        ))}
      </div>
    </div>
  )
}

export default AccordionSection